export default __webpack_public_path__ + "static/media/SBPay.e489431c.svg";